export { default as Teaser, type TeaserProps } from './Teaser';
